export const data = [
  {
    platform: "AN",
    version: "7.1",
    checksum: "Lvv7Hw3vhmO/Tcqqi5rnXc8INml=",
  },
  {
    platform: "IOS",
    version: "6.7",
    checksum: "e13be1e139bb2a681c87d286a768475ce5ea5347f16cecbd3eb05bca188a1a4",
  },
];
